// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MailTwoToneSvg from "@ant-design/icons-svg/es/asn/MailTwoTone";
import AntdIcon from '../components/AntdIcon';

var MailTwoTone = function MailTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: MailTwoToneSvg
  }));
};

MailTwoTone.displayName = 'MailTwoTone';
export default /*#__PURE__*/React.forwardRef(MailTwoTone);